
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ExperimentProduct {
  fdc_id: number;
  brand_owner: string;
  gtin_upc: number;
  ingredients: string;
  serving_size: number;
  serving_size_unit: string;
  household_serving_fulltext: string;
  branded_food_category: string;
  description: string;
  title: string;
  brand_name: string;
  subbrand_name: string;
  package_weight: string;
  image_url: string;
}

interface LinkedProductsListProps {
  products: ExperimentProduct[];
}

const LinkedProductsList: React.FC<LinkedProductsListProps> = ({ products }) => {
  if (!products || products.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Linked Products</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-6 text-muted-foreground">
            No products linked to this experiment yet.
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Linked Products</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {products.map((product) => (
            <div key={product.fdc_id} className="flex gap-4">
              {/* Product Image */}
              <div className="flex-shrink-0">
                {product.image_url ? (
                  <img
                    src={product.image_url}
                    alt={product.title}
                    className="w-16 h-16 object-cover rounded-md border"
                  />
                ) : (
                  <div className="w-16 h-16 bg-gray-100 rounded-md border flex items-center justify-center">
                    <span className="text-gray-400 text-xs">No Image</span>
                  </div>
                )}
              </div>

              {/* Product Details */}
              <div className="flex-1 min-w-0">
                <div className="mb-1">
                  <span className="font-medium text-sm">{product.title}</span>
                  {product.brand_name && (
                    <span className="text-sm text-muted-foreground ml-1">
                      ({product.brand_name})
                    </span>
                  )}
                </div>

                {product.ingredients && (
                  <p className="text-xs text-gray-600 line-clamp-2 leading-relaxed">
                    <span className="font-medium">Ingredients:</span> {product.ingredients}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default LinkedProductsList;
